import React, {useEffect, useState} from 'react';
import {NavLink} from 'react-router-dom';
import Icon from 'antd/es/icon';

const BottomNavbar = () => {
  const [data, setData] = useState({
    prevScrollPos: window.pageYOffset,
    visible: true,
  });

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [data.prevScrollPos]);

  const {prevScrollPos, visible} = data;

  // Hide or show the menu.
  const handleScroll = () => {
    const currentScrollPos = window.pageYOffset;
    const visible = prevScrollPos > currentScrollPos;

    setData({
      prevScrollPos: currentScrollPos,
      visible,
    });
  };

  return (
      <div className={visible ? 'mc-mottom-nav' : 'mc-mottom-nav hidden'}>
        <ul className="bottom-nav-list">
          <li>
            <NavLink to="/challenges/">
              <Icon type="edit" className="botton-nav-icon"/>
              <br/>
              <span>challenges</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/medpixx/">
              <Icon type="picture" className="botton-nav-icon"/>
              <br/>
              <span>medPixx</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/prepmed/">
              <Icon type="read" className="botton-nav-icon"/>
              <br/>
              <span>prepMed</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/mvideos/">
              <Icon type="video-camera" className="botton-nav-icon"/>
              <br/>
              <span>mVideos</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/mnotes/">
              <Icon type="file-text" className="botton-nav-icon"/>
              <br/>
              <span>mNotes</span>
            </NavLink>
          </li>
        </ul>
      </div>
  );
};

export {BottomNavbar};
